import utils from './utils';

const URL = `${BASE_API_URL}/expenses`;

export default {
    getSalaryProfile: id => utils.get(`${URL}/profiles/${id}.json`),
    updateSalaryProfile: (id, data) => utils.put(`${URL}/profiles/${id}.json`, data),
}



// WEBPACK FOOTER //
// ./src/api/expenses.js